module.exports = __webpack_public_path__ + "static/opal-a9ea39ca44164a9924387a4650462a0c.svg";